import { Box } from '@chakra-ui/react'
import type { MenuGroupProps } from './Menu'

export const MenuGroup = ({ children }: MenuGroupProps) => {
  return (
    <Box
      as="ul"
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        gap: {
          xl: 1,
        },
        width: '100%',
        listStyle: 'none',
      }}
    >
      {children}
    </Box>
  )
}
